import { SecondaryButton } from "../../../components/general/SecondaryButton.tsx";

export type DocumentDrawerNavBarProps = {
    title: string;
    showNavigation: boolean;
    currentIndex: number;
    totalDocuments: number;
    onPrevious: () => void;
    onNext: () => void;
    isDocumentLoading?: boolean;
    hasUnsavedChanges?: boolean;
    previousLabel?: string;
    nextLabel?: string;
    className?: string;
};

export function DocumentDrawerNavBar({
    title,
    showNavigation,
    currentIndex,
    totalDocuments,
    onPrevious,
    onNext,
    isDocumentLoading = false,
    hasUnsavedChanges = false,
    previousLabel = "Vorige",
    nextLabel = "Volgende",
    className = "",
}: DocumentDrawerNavBarProps) {
    const headerRowClass = `flex items-center justify-between w-full gap-6 ${className}`.trim();
    const leading = (
        <div className="min-w-0 flex-1">
            <div className="flex min-w-0 items-center gap-3">
                <h2 className="truncate text-2xl font-normal tracking-tight text-gray-900" title={title}>
                    {title}
                </h2>
                {hasUnsavedChanges && (
                    <span
                        role="status"
                        aria-label="Niet opgeslagen"
                        title="Niet opgeslagen"
                        className="mt-1 h-2 w-2 shrink-0 rounded-full bg-primary"
                    />
                )}
            </div>
        </div>
    );

    if (!showNavigation) {
        return <div className={headerRowClass}>{leading}</div>;
    }

    const navigationTooltip = (defaultTooltip: string) =>
        hasUnsavedChanges ? "Sla het document op voordat je verder gaat" : defaultTooltip;

    return (
        <div className={headerRowClass}>
            {leading}
            <div className="flex shrink-0 items-center gap-4">
                <span className="text-sm text-gray-500">
                    {currentIndex + 1}/{totalDocuments}
                </span>
                <SecondaryButton
                    title={previousLabel}
                    tooltip={navigationTooltip("Pijltje naar links")}
                    onClick={onPrevious}
                    disabled={
                        isDocumentLoading ||
                        hasUnsavedChanges ||
                        currentIndex <= 0 ||
                        totalDocuments <= 0
                    }
                />
                <SecondaryButton
                    title={nextLabel}
                    tooltip={navigationTooltip("Pijltje naar rechts")}
                    onClick={onNext}
                    disabled={
                        isDocumentLoading ||
                        hasUnsavedChanges ||
                        currentIndex < 0 ||
                        totalDocuments <= 0 ||
                        currentIndex >= totalDocuments - 1
                    }
                />
            </div>
        </div>
    );
}
